import React from "react";
import style from "./Homepage.module.css";
import { GoSearch } from "react-icons/go";
import {
    Box,
    Flex,
    Grid,
    Image,
    Select,
    Text,
    Button,
    Input,
    Circle,
} from "@chakra-ui/react";
import savings from "../../Images/Homepage/savings.png";
import builderProject from "../../Images/Homepage/builderProject.png";
import homeLoan from "../../Images/Homepage/homeLoan.png";
import propertySarvices from "../../Images/Homepage/propertyServices.png";
import noBrokerNri from "../../Images/Homepage/noBrokerNri.png";

import freeListing from "../../Images/Homepage/freeLisiting.png";
import shortlist from "../../Images/Homepage/shortlist.png";
import rentalAgree from "../../Images/Homepage/rental.png"


import mobile from "../../Images/Homepage/mobile.png"
import playStore from "../../Images/Homepage/playStore.png";
import appleStore from "../../Images/Homepage/iosDownload.svg"
import { bg_image, real_estate } from "../../Utils/export";
import PropertiesSection from "./PopularOwnerProperties";
import TopProjectsSection from "./TopProjects";
import PropertySearchBar from "./searchBar";
import TestimonialSection from "./TestimonialSection/TestimonialSection";

function Homepage() {
    const [selectedOpt, setSelectedOpt] = React.useState("Buy");
    return (
        <Box >

            <PropertySearchBar />
            <PropertiesSection />

            <TopProjectsSection />


            <Flex
                // bgColor="#384d6c"
                h="55px"
                justifyContent="center"
                alignItems="center"
                color="#fff"
                m="30px 0 5px 0"
                gap={2}
                fontSize="14px"
            >
                <Image src={savings} alt="savings" />
                <Text>
                    Do you know how much <Text as="b">loan</Text> you can get? Get maximum
                    with <Text as="b">121</Text>
                </Text>
                <a
                    // href="https://www.nobroker.in/prophub/home-loan/check-eligibility/?nbFr=HOME-BANNER-BUY&utm_medium=homepage&utm_source=desktopBanner"
                    target="_blank" rel="noreferrer"
                >
                    <Button
                        color="#464646"
                        bgColor="#fff"
                        fontSize="12px"
                        p="4px 8px"
                        h="fit-content"
                        borderRadius="4px"
                    >
                        Check Eligibility
                    </Button>
                </a>
            </Flex>
            <Flex className={style.optiosWithIcon} >
                <Box>
                    <Text>New</Text>
                    <Image src={builderProject} alt="builderProject"></Image>
                    <Text className="text-lg md:text-[22px] font-medium text-white">Builder Projects</Text>
                </Box>
                <Box>
                    <Text visibility="hidden"></Text>
                    <Image src={homeLoan} alt="homeLoan"></Image>
                    <Text className="text-lg md:text-[22px] font-medium text-white">Home Loan</Text>
                </Box>
                <Box>
                    <Text visibility="hidden"></Text>
                    <Image src={propertySarvices} alt="propertySarvices"></Image>
                    <Text className="text-lg md:text-[22px] font-medium text-white">Property Legal Services</Text>
                </Box>
                <Box>
                    <Text visibility="hidden"></Text>
                    <Image src={noBrokerNri} alt="noBrokerNri"></Image>
                    <Text className="text-lg md:text-[22px] font-medium text-white">121 for NRI’s</Text>
                </Box>
            </Flex>



            <Flex mt="30px" justifyContent="center" alignItems="center" gap={10}>
                <Text className={style.horizontalLineBox}>
                    <Text className={style.horizontalLine}></Text>
                    <Text className={style.redCircle}></Text>
                </Text>
                <Text align="center" fontSize="32px" color="#fff" minW="max-content" >
                    Why Use 121
                </Text >
                <Text className={style.horizontalLineBox}>
                    <Text className={style.redCircle}></Text>
                    <Text className={style.horizontalLine}></Text>
                </Text>
            </Flex>
            <Grid className={`${style.whyUseNoBroker} grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 p-4 text-center text-white`}>

                <Box>
                    <Image src={freeListing} alt="freeListing" />
                    <Text>Free Listing</Text>
                    <Text>Easy listing process. Also <br /> using WhatsApp</Text>
                </Box>
                <Box>
                    <Image src={shortlist} alt="shortlist" />
                    <Text>Shortlist without Visit</Text>
                    <Text>Extensive Information <br /> makes it easy</Text>
                </Box>
                <Box>
                    <Image src={rentalAgree} alt="rentalAgree" />
                    <Text>Rental Agreement</Text>
                    <Text>Assistance in creating Rental <br /> agreement & Paper work</Text>
                </Box>
            </Grid>


            <TestimonialSection />



            <Flex className={style.mobileIconBox} align="center" wrap="wrap">
                <Box>
                    {/* <Image src={real_estate} alt="mobile" width="250px" /> */}
                </Box>
                <Box ml={{ base: "0", md: "80px", lg: "120px" }} textAlign={{ base: "center", md: "left" }}>
                    <Text fontSize="32px" fontWeight="400" color="#fd3752">
                        Find A New Home On The Go
                    </Text>
                    <Box my="30px" className="text-white">
                        <Text fontSize="22px">Download our app</Text>
                        <Text fontSize="18px" fontWeight="300">
                            Where convenience is at your fingertip
                        </Text>
                    </Box>
                    <Flex justify={{ base: "center", md: "flex-start" }} gap="20px">
                        <a href="#" target="_blank" rel="noreferrer">
                            <Image src={playStore} alt="playStore" height="55px" width="220px" />
                        </a>
                        <a href="#" target="_blank" rel="noreferrer">
                            <Image src={appleStore} alt="appleStore" height="70px" width="220px" />
                        </a>
                    </Flex>
                </Box>
            </Flex>
        </Box>

    );
}

export default Homepage;
